import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 30px;
	width: 460px;
	padding: 30px;
	border-radius: 10px;
	background: #111314;
	box-shadow: 0 6px 80px 0 rgba(0, 0, 0, 0.5);
	border: 1px solid rgba(255, 255, 255, 0.1);
`;

export { StyledContainer };
